var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStepperActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5485",
    "data-name": "Group 5485",
    transform: "translate(-0.034)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(0.034)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons1",
    transform: "translate(8.593 8.593)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spinner--loading--dots-",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M46.03,29.433a2.418,2.418,0,1,1,2.418,2.418A2.419,2.419,0,0,1,46.03,29.433Z",
    transform: "translate(-27.581 -17.79)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M41.169,41.169a2.419,2.419,0,1,1,0,3.421A2.421,2.421,0,0,1,41.169,41.169Z",
    transform: "translate(-24.714 -24.714)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 2.418,
    cy: 2.418,
    r: 2.418,
    transform: "translate(9.225 18.449)",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M17.7,41.169a2.419,2.419,0,1,1-3.421,0A2.421,2.421,0,0,1,17.7,41.169Z",
    transform: "translate(-10.868 -24.714)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M12.837,29.433a2.418,2.418,0,1,1-2.418-2.418A2.419,2.419,0,0,1,12.837,29.433Z",
    transform: "translate(-8 -17.79)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M17.7,17.7a2.419,2.419,0,1,1,0-3.421A2.421,2.421,0,0,1,17.7,17.7Z",
    transform: "translate(-10.868 -10.868)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 2.418,
    cy: 2.418,
    r: 2.418,
    transform: "translate(9.225 0)",
    fill: "#fff",
    opacity: 0.1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperActive);
export default __webpack_public_path__ + "static/media/stepper-active.1f56a832c24be9b7fa273f7fa5e915cb.svg";
export { ForwardRef as ReactComponent };